import "./search-result.style.scss";

import { Col, Hr, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { getTaxonomyPath } from "@/common/helpers/taxonomy.util";
import { SearchResultProps } from "@/common/types/search-types";
import React, { FC } from "react";
import { Link } from "react-router-dom";

export const SearchResult: FC<SearchResultProps> = (props: SearchResultProps) => {
  const detailsPath = `/items/${getTaxonomyPath(props.taxonomyId)}`;

  return (
    <View className="catalog-result-view catalog-item">
      <Col gridGap="0px">
        <Link to={detailsPath} style={{ textDecoration: "none", color: "inherit" }} data-testid="search-result-link">
          <View padding={{ top: "20px", bottom: "20px" }} style={{ cursor: "pointer" }}>
            <Col gridGap="S200">
              <Row gridGap="S300">
                <View
                  display="flex"
                  height="78px"
                  padding="S100"
                  alignItems="flex-start"
                  className="img-square-wrapper"
                  style={{ borderRadius: "16px" }}
                >
                  <img
                    alt={props.name}
                    src={props.logoUrl?.trim() !== "" ? props.logoUrl : ""}
                    data-testid="catalog-item-url"
                    style={{
                      borderRadius: "16px",
                      width: "70px",
                      height: "70px",
                      objectFit: "contain",
                    }}
                  />
                </View>

                <Col gridGap="S200" data-testid="search-result-text">
                  <Text
                    fontSize="T200"
                    fontWeight="bold"
                    color="neutral90"
                    lineHeight="24px"
                    dataTestId="catalog-result-name"
                  >
                    {props.name}
                  </Text>
                  <Text
                    fontSize="T200"
                    fontWeight="regular"
                    color="neutral90"
                    lineHeight="24px"
                    dataTestId="catalog-result-short-description"
                  >
                    {props.shortDescription}
                  </Text>
                </Col>
              </Row>
            </Col>
          </View>
        </Link>
        <Hr />
      </Col>
    </View>
  );
};
